export const snakeToCamelCase = (str) => str.split("_").map((item, idx) => idx > 0 && item ? (item[0].toUpperCase() + item.slice(1)) : item).join("")

export const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const initialReg = str => str.replace(/[A-Z]/g, letter => `_${letter}`).split("_").map((item) =>  item[0].toUpperCase() + item.slice(1)).join(" ");
